import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Start from './components/Start';

// ── Lazy-loaded route components for code splitting ──
const Login    = lazy(() => import('./pages/Login'));
const Register = lazy(() => import('./pages/Register'));
const Home     = lazy(() => import('./pages/Home'));

// ── Minimal full-screen loader shown during lazy chunk loading ──
function AppLoader() {
  return (
    <div
      className="w-screen h-screen flex items-center justify-center bg-[var(--bg-primary)]"
      aria-label="Loading application"
      role="status"
    >
      <div className="flex flex-col items-center gap-4">
        <div
          className="w-12 h-12 rounded-2xl flex items-center justify-center"
          style={{ background: 'linear-gradient(135deg, #7C3AED 0%, #5B21B6 100%)', boxShadow: '0 8px 32px rgba(124,58,237,0.4)' }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" fill="white" fillOpacity="0.9"/>
          </svg>
        </div>
        <div className="w-6 h-6 border-2 border-[var(--accent)] border-t-transparent rounded-full animate-spin" aria-hidden="true" />
        <span className="sr-only">Loading…</span>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="bg-[var(--bg-primary)] min-h-screen">
      <Router>
        <Suspense fallback={<AppLoader />}>
          <Routes>
            <Route path="/login"    element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/chats"    element={<Home />} />
            <Route path="/"         element={<Start />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
